import { useTranslation } from 'react-i18next';
import { OfficialAccountFollowBtn } from '@/components';
import React from 'react';
import style from './index.module.css';
import { IconHiStar } from '@/assets/hi';
import { OfficialAccountVerifyStatus } from '@/hooks';

export interface HiOfficialFollowFixTipProps {
  officialAccountInfo: OfficialAccount;
}

export const HiOfficialFollowFixTip = ({ officialAccountInfo }: HiOfficialFollowFixTipProps) => {
  const { t } = useTranslation();

  return officialAccountInfo?.is_following ||
    officialAccountInfo?.verify_status !== OfficialAccountVerifyStatus.VERIFIED ? null : (
    <div className={style.fixTip}>
      <div className={style.tipArea}>
        <IconHiStar style={{ marginRight: 8 }} />
        <span className={style.tipText}>{t('HiFollowFixTip_officialAccount.1cnvno2')}</span>
      </div>
      <OfficialAccountFollowBtn officialId={officialAccountInfo.id} className={style.followBtn} />
    </div>
  );
};
